import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

export default function LeaderboardLoadingState() {
  return (
    <div
      className="flex min-h-[260px] flex-col items-center justify-center gap-2 px-4 text-center"
      role="status"
      aria-live="polite"
    >
      <div className="h-36 w-36 sm:h-40 sm:w-40" aria-hidden="true">
        <DotLottieReact
          src={`${process.env.PUBLIC_URL}/animations/walking-shoes.lottie`}
          autoplay
          loop
        />
      </div>
      <p className="m-0 text-sm font-medium text-slate-600 sm:text-base">
        Loading leaderboard…
      </p>
    </div>
  );
}
